import "react-app-polyfill/ie11";
import React, { useState, useCallback, useEffect } from "react";
import ReactDOM from "react-dom";
import Root from "./client_customizations/containers/Root/Root";
import { BrowserRouter as Router } from "react-router-dom";
import { IntlProvider } from "react-intl";
import * as serviceWorker from "./serviceWorker";
import "./utils/polyfills";
import messages_en from "./context/translations/en.js";
import messages_esp from "./context/translations/esp.js";
import "./main.scss";

const App = () => {
  const [language, setLanguage] = useState("EN");
  const [messages] = useState({
    EN: messages_en,
    ES: messages_esp,
  });

  const changeLanguage = useCallback((lang) => {
    localStorage.setItem("language", lang);
    setLanguage(lang);
  }, []);

  useEffect(() => {
    let key = localStorage.getItem("language");

    if (key) {
      setLanguage(key);
    }
  }, []);


  return (
    <IntlProvider locale={language} messages={messages[language]}>
      <Router>
        <Root language={language} changeLanguage={changeLanguage} />
      </Router>
    </IntlProvider>
  );
};

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);

// ReactDOM.render(
//   <IntlProvider locale={language} messages={messages[language]}>
//     <Router>
//         <Root changeLanguage={changeLanguage}/>
//     </Router>
//   </IntlProvider>,
//   document.getElementById("root")
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
